import styled from 'styled-components';
import getRem from 'utils/getRem';

export const Container = styled.div`
  display: flex;
`;

export const Column = styled.div`
  flex: 1 1 50%;

  &:first-of-type {
    margin-right: 60px;
  }
`;

export const ColumnTitle = styled.h4`
  margin: 0 0 18px 0;
  font-size: ${getRem(18)};
`;

export const Link = styled.a`
  display: block;
  margin-bottom: 15px;
`;
